import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'viTrustHtml',
  standalone: true,
})
export class ViTrustHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(value: string): SafeHtml {
    // Strip all HTML tags, (e.g. lorem <b>ipsum</b> -> lorem ipsum)
    value = value.replace(/<.*?>/g, '');
    // Create a bullet point list  *, (e.g. * lorem ipsum -> <ul> <li> lorem impsum </li> </ul>)
    const valueLines = value.split('\n').map((line) => {
      if (line.startsWith('* ')) {
        return line.replace(
          /^\*\s+(.*)/gi,
          '<ul style="list-style-type:disc; margin-left:16px"><li>$1</li></ul>'
        );
      }
      return line;
    });

    value = valueLines.join('\n');

    // Bold text between *, (e.g. lorem *ipsum* -> lorem <b>impsum</b>)
    value = value.replace(/\*\s*([^*]*?)\s*\*/gi, '<b>$1</b>');
    // Italic text between _, (e.g. lorem _ipsum_ -> lorem <i>impsum</i>)
    value = value.replace(/\_\s*([^*]*?)\s*\_/gi, '<i>$1</i>');
    // Replace new line with <br>, (e.g. lorem\nipsum -> lorem<br />ipsum)
    value = value.replace(/(?:\r\n|\r|\n)/gi, '<br />');
    // Replace new line with <br>, (e.g. lorem#nipsum -> lorem<br />< br/>ipsum)
    value = value.replace(/#/g, '<br />');
    // Add highligth class to element betwen `, (e.g. lorem `ipsum` -> lorem<span class="highlight" />ipsum</span>)
    // .highlight class can be adjusted with alternate-class-styling directive
    value = value.replace(/\`\s*([^*]*?)\s*\`/gi, '<span class="highlight">$1</span>');

    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
